import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots } from "vue"

import { useSlots } from "vue";
import { useStore } from "vuex";

import { PageContent, Toast } from "@lde/core_lde_vue";

import CommunicationsList from "@/components/communications/CommunicationsList.ts.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'PageLayout',
  setup(__props) {

const slots = useSlots();

const store = useStore();
const isLogged = store.getters?.isLogged;
const isCataloguePublicActif = store.getters?.isCataloguePublicActif;
const showTestBanner = process.env.VUE_APP_SHOW_TEST_BANNER === "true";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PageContent), null, _createSlots({ _: 2 }, [
    _renderList(_unref(slots), (_, name) => {
      return {
        name: name,
        fn: _withCtx(() => [
          (name === 'content' && _ctx.$store.getters?.isLogged)
            ? (_openBlock(), _createBlock(CommunicationsList, { key: 0 }))
            : (name === 'content' && !_unref(isLogged) && _unref(isCataloguePublicActif) && showTestBanner)
              ? (_openBlock(), _createBlock(_unref(Toast), {
                  key: 1,
                  id: "temp_banner_test",
                  variant: "warning",
                  title: _ctx.$t('catalogue-public.env-test-titre'),
                  content: _ctx.$t('catalogue-public.env-test-contenu'),
                  "show-icon": "",
                  "hide-close-btn": ""
                }, null, 8, ["title", "content"]))
              : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, name)
        ])
      }
    })
  ]), 1024))
}
}

})